<div class="action-type tw-flex tw-flex-col">
  <span class="action-type__label">
    {{ fieldLabel }}
  </span>
  <mat-radio-group
    [formControl]="activityTypeControl"
    [disabledControl]="disabled"
    [attr.test-id]="testId"
    class="tw-flex tw-space-x-8 tw-p-2"
  >
    <mat-radio-button [value]="uliActivityType.Outbound">
      {{ uliActivityType.Outbound | titlecase }}
    </mat-radio-button>

    <mat-radio-button [value]="uliActivityType.Inbound">
      {{ uliActivityType.Inbound | titlecase }}
    </mat-radio-button>
  </mat-radio-group>
</div>
